import enPolicies from './en';
import bgPolicies from './bg';
import { PolicyDocuments } from './types';

const policyMap: Record<string, PolicyDocuments> = {
  en: enPolicies,
  'en-US': enPolicies,
  'en-GB': enPolicies,
  bg: bgPolicies
};

export function getPolicyDocuments(locale?: string): PolicyDocuments {
  if (!locale) {
    return enPolicies;
  }

  // Exact match first
  if (policyMap[locale]) {
    return policyMap[locale];
  }

  // Fallback to language code
  const short = locale.split('-')[0];
  if (policyMap[short]) {
    return policyMap[short];
  }

  return enPolicies;
}
